import { Modal } from "@/components/ui";
import { TotpEnrollmentFlow } from "./TotpEnrollmentFlow";
import { authApi } from "@/lib/api";

export function TotpRotationModal({
  open,
  onClose,
  onComplete,
}: {
  open: boolean;
  onClose: () => void;
  onComplete: (recoveryCodes: string[]) => void;
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Regenerar codigos de recuperacion"
      description="Esto sustituye tu autenticador actual y revoca los codigos de recuperacion anteriores."
      size="sm"
    >
      <TotpEnrollmentFlow
        onEnroll={() => authApi.enrollTotp()}
        onConfirm={(enrollmentId, code) => authApi.confirmTotp({ enrollmentId, code }).then((r) => r.recoveryCodes)}
        onComplete={onComplete}
      />
    </Modal>
  );
}
